import { render, staticRenderFns } from "./config06-a-dianji.vue?vue&type=template&id=262b98e2&"
import script from "./config06-a-dianji.vue?vue&type=script&lang=js&"
export * from "./config06-a-dianji.vue?vue&type=script&lang=js&"
import style0 from "./config06-a-dianji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports